import constants from 'common/constants'

import {ONBOARDING_FILE_PREFILL} from './ActionTypes/ApiActionTypes'

/**
 * `POST onboarding/prefill`: the Teachers file, already uploaded in pieces, is read again in the
 * background for the Students and Teacher Allocation steps. Answers 202 with
 * `result.drafts: {students: {id, job}, allocation: {id, job}}`; each result is kept as a draft
 * titled `onboarding-prefill` (see ONBOARDING_PREFILL_DRAFT_TITLE), and a new call replaces the
 * previous drafts. Fire and forget: the steps read the drafts when they open.
 *
 * `sheetAssignments` carries the answers to the Teachers step's "whose list is this sheet?"
 * question (`{"<file>::<sheet>": "students"}`); without them a workbook of several unlabelled
 * lists is not read for either step.
 *
 * `uploadIds` sends every file of the Teachers step in one call, so the drafts cover them all.
 *
 * `columnAssignments` carries the answers to "which field is this column?", so the drafts read the
 * columns the same way the Teachers step did.
 *
 * `branchAssignments` carries the answers to "which branch are these students in?"
 * (`{"<file>::<sheet>": <branchId> | "mixed"}`), so the Students draft puts each sheet's rows in
 * the branch the user picked.
 *
 * `allocationAssignments` carries the answers to "which classes does this teacher teach?"
 * (`[{teacher, employeeId, subject, classIds}]`): one allocation line per picked class goes into
 * the Allocation draft, placed in exactly that class.
 *
 * @param {{uploadId?: string; uploadIds?: string[]; useCaseKeys?: string[]; sheetAssignments?: Record<string, string>; columnAssignments?: Record<string, string>; branchAssignments?: Record<string, number | 'mixed'>; allocationAssignments?: Array<{teacher: string; employeeId: string | null; subject: string; classIds: number[]}>}} body
 */
export const prefillOnboardingFromFile = (body, onSuccess, onFailure) => {
  return {
    type: ONBOARDING_FILE_PREFILL,
    payload: {
      apiUrl: constants.api_onboarding_prefill,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}
